import { FC, ReactNode } from 'react'

import Icon, { IconTypes } from '~ui/Icon'
import Heading from '~ui/Heading'

import styles from './wrapper.module.scss'

type TitleProps = {
  text: string
  iconName?: IconTypes
  color?: GThemeColorsNew
  colorGlow?: GThemeColorsNew
}

type TicketsWrapperProps = {
  title?: TitleProps
  children?: ReactNode
}

const TicketsWrapper: FC<TicketsWrapperProps> = ({ children, title }) => (
  <div className={styles.wrapper}>
    {title && (
      <Heading
        colorGlow={title.colorGlow}
        className={styles.title}
        color={title.color}
        Tag="span"
        uppercase
      >
        {title.iconName && (
          <Icon
            glowColor={title.colorGlow}
            className={styles.icon}
            name={title.iconName}
            color={title.color}
          />
        )}
        {title.text}
      </Heading>
    )}

    <div className={styles.body}>{children}</div>
  </div>
)

export default TicketsWrapper
